import type { FixingCompanyProps } from '@api/models/fixing-company';
import type { EditableDetailsItem } from '@client/components/EditableField';

export type FixingCompanyDetailsValues = Pick<
	FixingCompanyProps,
	'name' | 'address' | 'city' | 'country' | 'postalCode' | 'vatNumber'
>;

const getFixingCompanyItems = (
	fixingCompany?: FixingCompanyDetailsValues,
): Array<EditableDetailsItem<Partial<FixingCompanyDetailsValues>>> => [
	{
		key: 'name',
		label: 'Company name',
		value: fixingCompany?.name ?? null,
		type: 'text',
		editable: true,
		required: true,
	},
	{
		key: 'address',
		label: 'Address',
		value: fixingCompany?.address ?? null,
		type: 'text',
		editable: true,
		required: true,
	},
	{
		key: 'city',
		label: 'City',
		value: fixingCompany?.city ?? null,
		type: 'text',
		editable: true,
		required: true,
	},
	{
		key: 'country',
		label: 'Country',
		value: fixingCompany?.country ?? null,
		type: 'text',
		editable: true,
		required: true,
	},
	{
		key: 'postalCode',
		label: 'Postal code',
		value: fixingCompany?.postalCode ?? null,
		type: 'text',
		editable: true,
	},
	{
		key: 'vatNumber',
		label: 'VAT number',
		value: fixingCompany?.vatNumber ?? null,
		type: 'text',
		editable: true,
	},
];

export default getFixingCompanyItems;
